import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

/**
 * Radio del design system. Portado de `InputRadioComponent` del backoffice
 * (`src/components/input-radio/`), adaptado a signals.
 *
 * El control nativo va con `appearance: none` y el círculo lo pintan los SVG
 * de `public/icons/Input-Radio*.svg`, los mismos archivos que usa el
 * backoffice.
 */
@Component({
  selector: 'app-input-radio',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './input-radio.html',
  styleUrl: './input-radio.scss',
  host: {
    '[class]': 'deshabilitado() ? "input-radio--deshabilitado" : "input-radio"',
  },
})
export class InputRadio {
  readonly label = input<string>();
  readonly checked = input(false);
  readonly deshabilitado = input(false);
  /** Agrupa los radios que son mutuamente excluyentes. */
  readonly name = input<string>();

  readonly cambio = output<void>();

  /**
   * Id propio para que el `<label>` sea clickeable sin colisionar con otros
   * radios de la misma pantalla.
   */
  readonly idUnico = `input-radio-${Math.random().toString(36).slice(2, 11)}`;

  onChange(): void {
    if (this.deshabilitado()) return;
    this.cambio.emit();
  }
}
